import { Type } from 'typebox';
import { Attachment } from '../reference/attachment.js';
export const FamilyMediaReference = Type.Object({
    type: Type.String({ minLength: 1 }),
    identifier: Type.String({ minLength: 1 }),
    actorKey: Type.String({ minLength: 1 }),
    actorName: Type.String(),
    createdTimestamp: Type.Number(),
    subjectKey: Type.Optional(Type.String({ minLength: 1 })),
    date: Type.Optional(Type.String()),
    messageId: Type.Optional(Type.String({ minLength: 1 }))
});
export const FamilyMedia = Type.Object({
    key: Type.String({ minLength: 1 }),
    uuid: Type.String({ minLength: 1 }),
    deleted: Type.Boolean(),
    attachment: Type.Optional(Attachment),
    captureTimestamp: Type.Optional(Type.Number()),
    updateTimestamp: Type.Number(),
    latestSharedTimestamp: Type.Number(),
    actorKey: Type.String({ minLength: 1 }),
    locationKey: Type.Optional(Type.String({ minLength: 1 })),
    groupKeys: Type.Array(Type.String({ minLength: 1 })),
    subjectKeys: Type.Array(Type.String({ minLength: 1 })),
    note: Type.Optional(Type.String()),
    references: Type.Array(FamilyMediaReference)
});
